import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiUrls } from '@api/apiUrls';
import { IAccountHistoryProps } from '@components-member/TradingAccounts/interfaces';
import { TradingHistory } from '@components-shared/reports';
import { keyMap } from '@locales/lokalise/keyMap';
import { CURRENCY } from 'global.enums';

const TradingAccountHistory = (props: IAccountHistoryProps): JSX.Element => {
  const { account, accountId } = props;
  const { i18n } = useTranslation();

  const { platformType } = account;
  const isCentAccountType = account.currency === CURRENCY.USC;

  return (
    <>
      {isCentAccountType && (
        <div className="tab-panel__notification">
          <span>{i18n.t(keyMap.tradingAccountsAccountOrderHistory)}</span>
        </div>
      )}
      <div className="form-box">
        <h1 className="content__title">{i18n.t(keyMap.tradingAccountsAccountHistoryTitle)}</h1>
        <TradingHistory
          api={ApiUrls.tradingHistoryUser.grid}
          exportAPI={ApiUrls.tradingHistoryUser.export}
          platformType={platformType}
          accountId={accountId}
        />
      </div>
    </>
  );
};

export default TradingAccountHistory;
